import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RequestState } from '../../constants/request-state';
import { isRequestNone } from '../../utils';
import { amrCompaniesService } from '../../services/amr-companies.service';
import { arrangersActions } from '../../actions/entities/arrangers.actions';
import { AppState } from '../../types/state/AppState';
import { CompanyStatus } from "../../types/amr-pipeline/enums/CompanyStatus";

export function useArrangers() {
    const dispatch = useDispatch();
    const { requestState, items } = useSelector((state: AppState) => state.entities.arrangers);

    useEffect(() => {
        if (isRequestNone(requestState)) {
            const doRequest = async () => {
                dispatch(arrangersActions.request(RequestState.request));
                try {
                    const arrangers = await amrCompaniesService.getArrangersList(false, [CompanyStatus.Active, CompanyStatus.OffPlatform]);
                    dispatch(arrangersActions.response(RequestState.success, arrangers));
                } catch (e) {
                    dispatch(arrangersActions.request(RequestState.failure));
                }
            };

            doRequest();
        }
    }, [requestState, dispatch]);

    return { requestState, items };
}
